import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/utils/api"; // Register axios interceptor before anything else
import App from "@/App";

// En producción, silenciamos console.log/debug/info para evitar leak de info.
// console.error y console.warn se mantienen para detectar errores reales en producción.
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

// Suppress PostHog PerformanceServerTiming errors
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.('PerformanceServerTiming') || 
      args[0]?.includes?.('postMessage') ||
      (typeof args[0] === 'string' && args[0].includes('posthog'))) {
    return;
  }
  originalError.apply(console, args);
};

// Hide error overlay for PostHog errors
window.addEventListener('error', (event) => {
  if (event.message?.includes('PerformanceServerTiming') || 
      event.message?.includes('postMessage')) {
    event.stopImmediatePropagation();
    event.preventDefault();
    
    // Remove error overlay if it appears
    setTimeout(() => {
      const overlay = document.getElementById('webpack-dev-server-client-overlay');
      if (overlay) overlay.remove();
      
      // Also check for iframe overlay
      document.querySelectorAll('iframe').forEach(iframe => {
        if (iframe.style.position === 'fixed' && iframe.style.zIndex > 9999) {
          iframe.remove();
        }
      });
    }, 100);
    
    return true;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
